import React from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-rte';
import Textinput from './textinput';
import AllowedUsers from './allowedUsers';

const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN'],
    INLINE_STYLE_BUTTONS: [
      {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
      {label: 'Italic', style: 'ITALIC'},
      {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_DROPDOWN: [
      {label: 'Normal', style: 'unstyled'},
      {label: 'Heading Large', style: 'header-one'},
      {label: 'Heading Medium', style: 'header-two'},
      {label: 'Heading Small', style: 'header-three'}
    ]
};

const DEFAULT_BODY = `<br/><p><img src='${window.location.origin}/img/directHedgeEmailSignatur.jpg'/></p><p>Yours sincerely,<br/>Direct Hedge</p>`;
const DEFAULT_STYLE = '<style>p { margin-top: 0; margin-bottom: 0; }</style>';

class CustomNotificationPopup extends React.Component {
    constructor(props) {
        super(props);
        this.initialState = {
            body: RichTextEditor.createValueFromString(DEFAULT_BODY, 'html'),
            sendPush: false,
            subject: '',
            selectedProducts: '',
            submitClicked: false,
			allowedUserIds: [],
			allUsers: []
        };
        this.state = this.initialState;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);  
		this.refreshSelectedUsersWithNotifications = this.refreshSelectedUsersWithNotifications.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { visible } = this.props;
        if (nextProps.visible && !visible) {
            this.setState(this.initialState);
        }
    }

	closePopup(e) {
        if (e.target.getAttribute('name') == 'customNotificationPopup') {
            this.props.hidePopup();
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        this.setState({
            [name]: value
        });
    }

    refreshSelectedUsersWithNotifications(selectedProducts) {
		this.props.getUsersWithNotification({ product_id: selectedProducts }, (users) => {
			this.setState({ allUsers: users, allowedUserIds: users.map(user => user.id) });
		});
    }

    areProductsSelected(product_ids) {
        const { selectedProducts } = this.state;
        return product_ids.every(id => selectedProducts.split(',').indexOf(id.toString()) >= 0);
    }

    handleProductsChange(event, product_ids) {
        const { selectedProducts } = this.state;
        const newSelectedProducts = selectedProducts && selectedProducts.split(',') || [];
        
        if (event.target.checked) {
            product_ids.forEach(id => {
                if (newSelectedProducts.indexOf(id.toString()) < 0) {
                    newSelectedProducts.push(id.toString());
                }
            });
        } else {
            product_ids.forEach(id => {
                if (newSelectedProducts.indexOf(id.toString()) >= 0) {
                    newSelectedProducts.splice(newSelectedProducts.indexOf(id.toString()), 1);
                }
            });
        }
        
        this.setState({ selectedProducts: newSelectedProducts.join(',') });
		this.refreshSelectedUsersWithNotifications(newSelectedProducts.join(','));
    }

    handleSubmit() {
        const { body, subject, sendPush, selectedProducts, allowedUserIds } = this.state;

        if (body && subject && selectedProducts) {
            this.props.sendCustomNotification({
                rawHTMLBody: body.toString('html').replace(/\n/g, '<br/>') + DEFAULT_STYLE,
                subject,
                selectedProducts,
				allowedUserIds,
                sendPush
            });
        } else {
            this.setState({
                submitClicked: true
            });
            this.props.showPopup({
                title: 'ERROR',
                content: 'Please choose at least one user group and fill in email subject and body.',
                buttonText: 'Ok'
            });
        }
    }    

	render() {
        const { body, subject, sendPush, selectedProducts, submitClicked } = this.state;
        const { markets, products } = this.props;
        const isSelectedProductsInvalid = submitClicked && selectedProducts == '';
        const isSubjectInvalid = submitClicked && subject == '';

        return (
            <div name='customNotificationPopup' className='generic-popup-container'
                onClick={(e) => this.closePopup(e) }
                style={{display: this.props.visible ? 'block' : 'none' }}>
                <div className='custom-notification-inner'>
                	<center>
                        <h2 className='title'>Send custom notification</h2>
                    </center>

                    <div className={`field-wrap ${isSelectedProductsInvalid ? 'error' : ''}`}>
                        <label className='labelactive'>User group *</label>
                        <ul>
                            {markets.map((market, i) => {
                                const marketProducts = products.filter(p => p.market_id == market.id);
                                const allProductIds = marketProducts.map(product => product.id);

                                return (
                                    <li key={'group' + market.name}>                    
                                        <input type='checkbox' onChange={(e) => this.handleProductsChange(e, allProductIds)}
                                            checked={this.areProductsSelected(allProductIds)} />
                                        <div className='checkbox-title'>{market.name}</div>
                                        <ul>
                                            {marketProducts.map(product => 
                                                <li key={'prod' + product.id} className='filter-child'>                    
                                                    <input type='checkbox' onChange={(e)=>this.handleProductsChange(e, [product.id])}
                                                        checked={this.areProductsSelected([product.id])} />
                                                    <div className='checkbox-title'>{product.short_name}</div>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                );                
                            })}
                        </ul>
                    </div>

                    <Textinput
                        label='Email subject line'
                        name='subject'
                        value={subject}
                        onChange={this.handleChange}
                        required={true}
                        invalid={isSubjectInvalid}
                        type='text' />

                    <br/>
                    <div className='field-wrap'>
                        <label className='labelactive'>Email body</label>
                        <RichTextEditor 
                            value={body} 
                            onChange={(body) => this.setState({body})} 
                            toolbarConfig={toolbarConfig}
                            className='custom-notif-editor'
                        />
                    </div>

                    <div className='field-wrap'>
                        <input
                            type='checkbox'
                            name='sendPush'
                            checked={sendPush}
                            onChange={this.handleChange} />
                        <label htmlFor='send-push' className='checkbox-label'>Send subject line as push notification</label> 
                    </div>

                    <div className='field-wrap'>
                        <a 
                            htmlFor='allowed_users' 
                            className={`label ${this.state.filter_users_collapsed ? 'icon-open' : 'icon-close'}`}
                            onClick={() => this.setState({ filter_users_collapsed: !this.state.filter_users_collapsed })}>
                            Filter users receiving notifications
                        </a>
                        <AllowedUsers
                            style={{display: this.state.filter_users_collapsed ? 'block' : 'none'}}
                            users={this.state.allUsers}
                            allowedUsers={this.state.allowedUserIds}
                            onChange={(newAllowedUsers) => this.setState({ allowedUserIds: newAllowedUsers })} 
							/>                        
                    </div>

                    <button
                        onClick={this.handleSubmit}
                        className='button button-block'>
                        Send
                    </button>
                </div>
            </div>
        )
    }
}

CustomNotificationPopup.propTypes = {
	hidePopup: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
    products: PropTypes.array,
    markets: PropTypes.array,
    sendCustomNotification: PropTypes.func.isRequired,
    showPopup: PropTypes.func.isRequired,
};

CustomNotificationPopup.defaultProps = {
    products: [],
    markets: [],
}

export default CustomNotificationPopup;


// WEBPACK FOOTER //
// ./source/components/CustomNotificationPopup.js